<template>
  <div :class="['', $store.state.common.theme!=3?'container':'container_theme_3']">
     <div v-if='isCity' class="topSelect" @click="selectM()">
           <img src="../../assets/images/icon_location_white.png"  class="topSelect_location"/>
           <span class="topSelect_span">{{ selectmarket? selectmarket.marketName:"请选择项目"}}</span>
           <img src="../../assets/images/themes/icon_arrows_filter_1.png"  class="topSelect_arrow"/>
        </div>
      <div class="body" v-if="pageShow">
        <div :class="['topView', isCity?'topViewtop':'']">
            <div class="bulidname" @click="select" v-if="companyObjList.length > 0">
                <span class="bulidname_span">{{activeCompanyName}}</span>
                <img src="../../assets/images/icon_arrows_filter_normal.png"  class="bulidname_arrow"/>
            </div>
            <!-- <img @click="getTenantQrCode" :src="QRCode" class="qrCode_icon"/> -->
            <div @click="refushQrCode" class="qrCode_icon" ref="qrCodeUrl"></div>
            <div  class="refushView">
                 <img @click="refushQrCode" class="refush_icon" src="../../assets/images/icon_qrcode_refresh_small.png">
                 <span @click="refushQrCode" class="refush_span1">点击二维码</span>
                 <span @click="refushQrCode" class="refush_span2">刷新</span>
            </div>
        </div>

        <img class="tipImg" src="../../assets/images/accessTip.png" />
      </div>

     <mt-popup v-model="popupVisible" position="bottom" class="mint-popup">
            <mt-picker class="picker" :slots="dataList" @change="onValuesChange" :visible-item-count="5" :show-toolbar="true" ref="picker">
            <div class="picker_wrap">
                <div class="picker_btn" @click="popupVisible=false">取消</div>
                <div class="picker_title">选择楼栋</div>
                <div class="picker_btn2" @click="handleConfirm">确认</div>
            </div>
            </mt-picker>
     </mt-popup>


       <!-- // 此处slots为动态传入的值，通过computed来处理，数据通过vuex管理，由于数据为对象数组，需设置 value-key 属性来指定显示的字段名 -->
        <mt-popup  v-model="mpopupVisible" position="bottom" class="mint-popup">
        <mt-picker class="picker" :slots="pickList" @change="monValuesChange" :visible-item-count="5" :show-toolbar="true" ref="mpicker" >
            <div class="picker_wrap">
                <div class="picker_btn" @click="mpopupVisible=false">取消</div>
                <div class="picker_btn2" @click="mhandleConfirm">确认</div>
            </div>
            </mt-picker>
        </mt-popup>

  </div>
</template>

<script>
import{getTenantBuildList,desEncrypt,transformToBase64}from "../../utils/api";
import util from "../../utils/util";
import QRCode from 'qrcodejs2'
import { mapState ,mapActions} from "vuex";
import wx from 'weixin-js-sdk'
//import wx from 'jweixin-1.6.0'


export default {
  name: "accessControl",
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
     // marketList
       selectmarket:'',
       isCity:false,
       qrcodeTool:'',
       timer:'',
       gpsLatitude:'',//纬度
       gpslongitude:'',//经度
       buildIndex:0,
       companyObjList: [],
       companyList: [],
       buildNameList:[],
       floorNameList:[],
       timestamp:'',
       activeCompanyName: '',
       floorName:"",
       buildName:'',
       QRCode:'',
       ID:'',
       pageShow:false,
       hasData:true,
       noDataText:'',
       popupVisible: false,
       popupVisible_fang:false,
       dataList:[],
       mpopupVisible:false,
       mpIndex:'',
       marketList:[],
       mNameList:[],
       pickList:[],
    };
  },
  activated() {

    //  var ju1 = util.distance(31.23037,121.4737,31.19833852,121.31106567)
    //  var ju2 = util.distance(31.23037,121.4737,31.1942388,121.3200329)
    //  var ju3 = util.distance(31.23037,121.4737,31.2139135,121.4486073)
    //  console.log(ju1 +' ' +ju2 +" " + ju3);
    setTimeout(() => {
        if(this.common.userId){
          if(this.$route.query.cityId){
              var that =this;
              that.isCity =true;
              console.log("in getLocation ready")
              wx.ready(()=>{
                console.log("in getLocation")
                wx.getLocation({
                  type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                  success: function (res) {
                  // console.log(res)
                    that.gpsLatitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                    that.gpslongitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                  },
                  fail:function(res){
                  // console.log(res)
                  },
                  complete:function() {
                      that.selectmarketAction();
                  }
                });
              })
          // this.queryParkHeaderList();
          }else{
            //  this.gpsLatitude =31.1942388;
            //  this.gpslongitude =121.3200329;
            //  this.selectmarketAction();

            this.getTenantBuildList();
          }

        }else{
          this.$router.push({
            path:'/login',
            query:{
              Rurl:this.$route.fullPath
            }
          });
        }
     }, 1000);
  },
  destroyed() {
     clearTimeout(this.timer);
  },
  methods: {
    ...mapActions(['getMarketInfo','getUserInfo','getTenantInfo',
    'getTenantInfoList','getTheme']),
    //pick选择楼栋楼层
    //定位自动选择
    selectmarketAction(){
       if(this.selectmarket){   //已经选择过就不选了
         this.getTenantBuildList();
         return;
       }
      //  var dis1 =
        // util.showModal("","定位回来了经纬度 " +this.gpsLatitude+" , " + this.gpslongitude,false,"知道了",() => {
        //         //this.$router.push("/companyList");
        //          });

       var vmarketList =  this.common.marketList;
       var mList =[];
       this.mNameList =[];
       for(var i=0;i<vmarketList.length;i++){
         var jList=vmarketList[i].cityMarkets;
         for(var j=0;j<jList.length;j++){
           mList.push(jList[j]);
           this.mNameList.push(jList[j].marketName)
         }
       }
       this.marketList =mList;
      // console.log(JSON.stringify(vmarketList[0].cityMarkets) )
       if(mList.length>0){
          var item0 = mList[0];
          //vmarketList[0].cityMarkets[0];
         // var distance0 = util.distance(this.gpsLatitude,this.gpslongitude,item0.latitude,item0.longitude)
          var distance = util.distance(this.gpsLatitude,this.gpslongitude,item0.latitude,item0.longitude)
          if(isNaN(distance) ){
             distance =100000;
          }
          console.log(distance)
          this.selectmarket = item0;
          for(var n = 0;n<mList.length;n++){
              var item = mList[n]
              var distanceI = util.distance(this.gpsLatitude,this.gpslongitude,item.latitude,item.longitude)
              if(isNaN(distanceI) ){
                  distanceI =100000;
              }
             if(distance > distanceI){
                //   util.showModal("",distanceI+ " 距离= " + distance + " 坐标 ="+ item.latitude +' ,' +item.longitude,false,"知道了",() => {
                // //this.$router.push("/companyList");
                //  });
                  distance = distanceI;
                  console.log(distance)
                  this.selectmarket = item;
              }
          }
          // var itemn = mList[mList.length-1];
          // var distancen = util.distance(this.gpsLatitude,this.gpslongitude,itemn.latitude,itemn.longitude)
          //  util.showModal("",distance+ " 距离= "+ " 坐标 ="+ this.selectmarket.latitude +' ,' +this.selectmarket.longitude,false,"知道了",() => {
          //       //this.$router.push("/companyList");
          //        });
       }
      //  console.log("this.selectmarket");
      //  console.log(JSON.stringify(this.selectmarket) );
       this.getTenantBuildList();
    },


    select() {
        this.popupVisible = true;
        var  complainTypeList = [{
                flex: 1,
                values: this.companyList,
                className: 'slot1',
                textAlign: 'center'
            }]
      
        this.dataList = complainTypeList ;
    },
    onValuesChange(picker, values) {
      if (values[0] > values[1]) {
        picker.setSlotValue(1, values[0]);
      }
    },
    handleConfirm() {
        this.popupVisible = false
        let valve = this.$refs.picker.getValues()[0];
        for (let i = 0; i < this.companyList.length; i++) {
          if (this.companyList[i] == valve) {
              this.buildIndex=i;
              this.activeCompanyName = this.companyList[i]
              this.floorName = this.floorNameList[i]
              this.buildName = this.buildNameList[i]
              //this.getTenantQrCode();
              this.refushQrCode();
          }
       }
    },

    //获取楼栋楼层
    getTenantBuildList() {
        util.showLoading();
        var marketId= this.common.marketInfo.id;
        if(this.selectmarket){
          marketId= this.selectmarket.marketId
        }
        getTenantBuildList({
          'userId': this.common.userId,
          'marketId':marketId
        }).then(res => {
          console.log(res,'in thislll')
          util.hideLoading();
          this.timestamp = res.res.timestamp;
          if (res.res.code === 10000) {
            this.pageShow = true;
            this.companyObjList = res.body.buildOutputs || [];
            console.log("this.companyObjList",this.companyObjList)
            this.companyList = [];
            for (var i = 0; i < this.companyObjList.length; i++) {
              
              if(this.companyObjList[i].buildingName){
                
                
                this.buildNameList =[];
                this.floorNameList =[];
                this.companyList.push(this.companyObjList[i].buildingName+"_"+this.companyObjList[i].floorName)
                
                this.buildNameList.push(this.companyObjList[i].buildingName)
                this.floorNameList.push(this.companyObjList[i].floorName)
              }
            }
            
            if(this.buildIndex ==0){
              if(!res.body.defaultFloor ||!res.body.defaultBuilding){
                this.activeCompanyName = this.companyList[0]
                this.floorName = this.floorNameList[0]
                this.buildName = this.buildNameList[0]
              }else{
                this.activeCompanyName = res.body.defaultBuilding + "_" + res.body.defaultFloor
                this.floorName = res.body.defaultFloor
                this.buildName = res.body.defaultBuilding
              }
            }
            console.log("this.companyList",this.companyList);
            
            this.getTenantQrCode();
          } else {
            this.hasData = false;
            this.pageShow = false;
            this.qrcodeTool ='';
            this.noDataText = res.res.msg;
            if(this.isCity){
              util.showModal("",res.res.msg,false,"知道了",() => {
                //this.$router.push("/companyList");
              });
            }else{
              util.showModal("",res.res.msg,true,"去认证",() => {
                 this.$router.push("/companyList");
              });
            }

          }
        })
      },
       refushQrCode() {
          var marketId= this.common.marketInfo.id;
          if(this.selectmarket){
            marketId= this.selectmarket.marketId
          }
          getTenantBuildList({
              'userId': this.common.userId,
              'marketId':marketId
          }).then(res => {
             // console.log(res)
              this.timestamp = res.res.timestamp; //主要用于获取 服务器端的时间
              this.getTenantQrCode();
          })
       },

      //获取二维码数据
      getTenantQrCode() {
        util.showLoading();
        var marketId= this.common.marketInfo.id;
          if(this.selectmarket){
            marketId= this.selectmarket.marketId
          }
        let content = {
          uid: this.common.userId,
          operationType: "1", //1门禁,2访客，3.会议室
          userId: this.common.userId,
          marketId: marketId,
          timestamp: this.timestamp.toString()
        };
        desEncrypt(content).then(res => {
          util.hideLoading();
         // console.log(res)
          this.pageShow = true;
          this.hasData = true;
          var content_m = res;
          this.creatQrCode(content_m);
        })
      },
      //js生成二维码
      creatQrCode(dic) {
        if(!this.qrcodeTool){
          var wh =document.body.clientWidth;
           var w =190*wh/375;
           var h =190*wh/375;
           this. qrcodeTool = new QRCode(this.$refs.qrCodeUrl, {
                    text: dic,
                    //JSON.stringify(map).replace(/(\")/g,"\\$1"),
                    width: w,
                    height: h,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.M
                })
        }else{
            this.qrcodeTool.clear(); // 清除代码
            this.qrcodeTool.makeCode(dic)
            // this.qrcodeTool.makeCode(JSON.stringify(map).replace(/(\")/g,"\\$1")); // 生成另外一个二维码
        }
        clearTimeout(this.timer)
        this.timer = setTimeout(() => this.refushQrCode(), 10*60*1000) //十分钟自动刷新
      },

      //获取二维码
      getQRCode(code) {
            let content = {
                qrcode: code,
                width:190,
                height:190,
            }
            transformToBase64(content).then(res => {
                if (res.res.code === 10000) {
                    //console.log("res二维码")
                   // console.log(res)
                   this.QRCode = res.body.encodeBase64;
                //    clearTimeout(timer)
                //    timer = setTimeout(() => this.getTenantBuildList(), 30000)
                }
           });
     },

     selectM() {
        this.mpopupVisible = true;
        var  complainTypeList = [{
                flex: 1,
                values: this.mNameList,
                className: 'slot1',
                textAlign: 'center'
            }]
        this.pickList = complainTypeList ;
    },
    monValuesChange(picker, values) {
      if (values[0] > values[1]) {
        picker.setSlotValue(1, values[0]);
      }
    },
    mhandleConfirm() {
        this.mpopupVisible = false
        let valve = this.$refs.mpicker.getValues()[0];
        for (let i = 0; i < this.mNameList.length; i++) {
          if (this.mNameList[i] == valve) {
              this.mpIndex=i;
              this.selectmarket = this.marketList[i];
          }
       }
       this.getTenantBuildList();
    },

  }

};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background:#0644A9 url('../../assets/images/accessBg.jpg') left bottom no-repeat;
  background-size:100% auto;
}
.container_theme_3{
  background: #ECE3C9;
  background-size:100% auto;
}
.body{
    width: 100%;
    height: 100%;
    flex-direction: column;
    position: relative;

}
.bgImage{
    width: 100%;
    height: 100%;
    object-fit:cover;
    z-index: 1;
}
.topSelect{
  height:60px;
  display: inline-block;
  // width: 100px;
  background:rgba(255,255,255,0.2);
  border-radius:30px;
  margin-top: 28px;
  margin-left: 40px;
  padding-left: 15px;
  padding-right: 15px;
  flex-direction: row;
  // justify-content: center;
  // align-items: center;
  .topSelect_location{
      // margin-top: 13px;
      width: 32px;
      height: 32px;
  }
  .topSelect_span{
    display: inline-block;
    // background-color: red;
    margin-top: 10px;
    margin-left: 8px;
    margin-right: 8px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:40px;
  }
  .topSelect_arrow{
      // margin-top: 10px;
      width: 24px;
      height: 24px;
  }
}

.topView{
    // position:absolute;
    // left: 40px;
    // top: 40px;
    margin-top: 80px;
    margin-left: 40px;
    margin-right: 40px;
    width:89.3%;
    // height:704px;
    background:rgba(255,255,255,1);
    border-radius:8px;
    display: flex;
    flex-direction: column;
    //justify-items: center;
     //justify-content: center;
     align-items: center;
   // align-content: center;
}
.topViewtop{
  margin-top:40px;
}

.topimg{
    width: 100%;
    height:100px ;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;

}
.bulidname{
    margin-top: 80px;
    flex-direction: row;
    align-items: center;
}
.bulidname_span{
    font-size:32px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:44px;
    max-width: 400px;
}
.bulidname_arrow{
    margin-left: 10px;
    width: 24px;
    height: 24px;
}

.qrCode_icon{
    margin-top: 86px;
    width: 380px;
    height: 380px;
}
.refushView{
    margin-top: 60px;
    margin-bottom: 110px;
    flex-direction: row;
}
.picker_title{
    margin-top: 22px;
    height:44px;
    font-size:32px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:44px;
}

.refush_icon{
    width: 28px;
    height: 28px;
}
.refush_span1{
    margin-left: 14px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:40px;
}
.refush_span2{
   margin-left: 8px;
   height:40px;
   font-size:28px;
   font-weight:400;
   color:rgba(23,64,218,1);
   line-height:40px;
}

.tipImg{
    margin-top: 20px;
    margin-left: 40px;
    width: 670px;
    height: 128px;
    border-radius:8px;
}

</style>